<script setup>
const props = defineProps({
  secondary: Boolean,
  link: String,
})
</script>

<template>
  <a :href="link" class="btn" :class="secondary ? 'secondary' : ''">
    <button>
      <p class="text-s"><slot></slot></p>
    </button>
  </a>
</template>

<style scoped>
.btn {
  text-decoration: none;
  width: fit-content;
  button {
    outline: none;
    width: fit-content;
    min-width: clamp(154px, 10.694vw, 770px);
    height: clamp(48px, 3.333vw, 240px);
    padding: clamp(14px, 0.972vw, 70px) clamp(21px, 1.458vw, 105px);
    cursor: pointer;

    border-radius: clamp(4px, 0.278vw, 20px);
    border: 1px solid #FFF;
    background: #4D46F8;
    box-shadow: 0px 4px 18px 0px rgba(255, 255, 255, 0.25);
    transition: background .3s ease;

    p {
      color: #FFF;
      font-family: "Orbitron", sans-serif;
      font-weight: 800;
      text-transform: capitalize;
      transition: color .3s ease;
    }
    &:hover {
      background: #FFF;
      p {
        color: #4D46F8;
      }
    }
  }

  &.secondary {
    button {
      background: none;
      &:hover {
        background: #4D46F8;
        p {
          color: #FFF;
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .btn, .btn button {
    width: max-content;
  }
}
</style>